import {
  Stack,
  DefaultPalette,
  Separator,
} from "@fluentui/react";
import SideBarNav from "./SideBarNav";
import addovation from "../assets/addovationShareLogo.svg";
import { useTheme } from "../theme/OAS365Theme";
import SidebarBottomFeatures from "./SidebarBottomFeatures";
import {
  getSidebarWidth,
  SIDEBAR_LOGO_AREA_HEIGHT_PX,
} from "../layout/sidebarLayout";

const SideBar = ({ collapsed = false }) => {
  const theme = useTheme();
  const sidebarWidth = getSidebarWidth(collapsed);

  return (
    <>
      <Stack
        verticalFill
        enableScopedSelectors
        styles={{
          root: {
            overflow: "hidden",
            background: theme.colors.backgroundColor,
            height: "100vh",
            width: sidebarWidth,
          },
        }}
        tokens={{ childrenGap: 0, padding: 0 }}
      >
        <Stack.Item
          disableShrink
          styles={{
            root: {
              padding: collapsed ? 0 : "8px 0px 0px 0px",
              background: theme.colors.backgroundColor,
              alignItems: "center",
              display: "flex",
              height: SIDEBAR_LOGO_AREA_HEIGHT_PX,
              justifyContent: "center",
              overflow: "hidden",
              width: sidebarWidth,
              flexShrink: 0,
            },
          }}
        >
          {!collapsed && (
            <img width={210} id="addovation" src={addovation} alt="Addovation" />
          )}
        </Stack.Item>

        <Stack.Item
          grow={collapsed}
          styles={{
            root: {
              alignItems: "stretch",
              background: theme.colors.backgroundColor,
              color: DefaultPalette.white,
              display: "flex",
              justifyContent: "flex-start",
              overflow: "hidden",
              width: sidebarWidth,
              maxWidth: sidebarWidth,
              flex: collapsed ? 1 : undefined,
            },
          }}
        >
          <SideBarNav collapsed={collapsed} />
        </Stack.Item>

        {!collapsed && (
          <Stack.Item styles={{ root: { width: sidebarWidth } }}>
            <Separator
              styles={{
                root: [
                  {
                    selectors: {
                      "::before": { background: theme.colors.backgroundColor },
                    },
                  },
                ],
              }}
            />
          </Stack.Item>
        )}

        <Stack.Item
          disableShrink
          styles={{
            root: {
              background: theme.colors.backgroundColor,
              height: collapsed ? "auto" : 105,
              width: sidebarWidth,
              display: "flex",
              overflow: "hidden",
              paddingBottom: collapsed ? 8 : 0,
            },
          }}
        >
          <SidebarBottomFeatures dialogHost={false} collapsed={collapsed} />
        </Stack.Item>
      </Stack>
    </>
  );
};

export default SideBar;
